/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import {
	HttpInterceptor,
	HttpEvent,
	HttpResponse,
	HttpRequest,
	HttpHandler,
	HttpErrorResponse,
	HttpParams,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { LoadingService } from './../../loading.service';
import { InterceptedHttpParams } from './intercepted-http-params';

@Injectable()
export class HttpInterceptorSpinLoader implements HttpInterceptor {
	private loadingService = inject(LoadingService);

	apiUrl: string;

	constructor() {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const loadingOptions = this.loadingSpinnerOptions(request.params);

		if (!loadingOptions.disable) {
			this.loadingService.setLoading(true, request.url, loadingOptions.target);
		}

		return next
			.handle(request)
			.pipe(
				catchError((error: HttpErrorResponse) => {
					this.switchOffLoadingSpinner(request, loadingOptions);
					return throwError(error);
				}),
				finalize(() => this.switchOffLoadingSpinner(request, loadingOptions))
			)
			.pipe(
				map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
					if (evt instanceof HttpResponse) {
						this.switchOffLoadingSpinner(request, loadingOptions);
					}
					return evt;
				})
			);
	}

	private loadingSpinnerOptions(params: HttpParams): { disable: boolean; target: string } {
		if (params instanceof InterceptedHttpParams) {
			return {
				disable: params.interceptorConfig?.noLoadingSpinner === true,
				target: params.interceptorConfig?.targetLoadingSpinner ?? LoadingService.DEFAULT_TARGET,
			};
		}
		return { disable: false, target: LoadingService.DEFAULT_TARGET };
	}

	private switchOffLoadingSpinner = (
		request: HttpRequest<any>,
		loadingOptions: { disable: boolean; target: string }
	): void => {
		if (!loadingOptions.disable) {
			this.loadingService.setLoading(false, request.url, loadingOptions.target);
		}
	};
}
